import createIcon from '../../createIcon';

/**
 * @component @name CatchingPokemon
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSAxMkMxNC41IDEzLjM4IDEzLjM4IDE0LjUgMTIgMTQuNUMxMC42MiAxNC41IDkuNSAxMy4zOCA5LjUgMTJDOS41IDEwLjYyIDEwLjYyIDkuNSAxMiA5LjVDMTMuMzggOS41IDE0LjUgMTAuNjIgMTQuNSAxMlpNMjIgMTJDMjIgMTcuNTIgMTcuNTIgMjIgMTIgMjJDNi40OCAyMiAyIDE3LjUyIDIgMTJDMiA2LjQ4IDYuNDggMiAxMiAyQzE3LjUyIDIgMjIgNi40OCAyMiAxMlpNMjAgMTJIMTZDMTYgOS43OSAxNC4yMSA4IDEyIDhDOS43OSA4IDggOS43OSA4IDEySDRDNCAxNi40MSA3LjU5IDIwIDEyIDIwQzE2LjQxIDIwIDIwIDE2LjQxIDIwIDEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CatchingPokemon = createIcon('CatchingPokemon', [
  [
    'path',
    {
      d: 'M14.5 12C14.5 13.38 13.38 14.5 12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5C13.38 9.5 14.5 10.62 14.5 12ZM22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12ZM20 12H16C16 9.79 14.21 8 12 8C9.79 8 8 9.79 8 12H4C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12Z',
      key: 'mbymn2',
    },
  ],
]);

export default CatchingPokemon;
